import Empty from "@component-ui/Empty";

const PreviewError = () => {
    return (
        <Empty label="Link expired or you are not authorized" />
    );
};

export default PreviewError;
